import styled from 'styled-components'

const MARGIN = '9px'

export const PriceSummary = styled.div<{
  bundleHasAnyDiscount?: boolean
  $insideSummaryPanel?: boolean
}>`
  ${(props) => props.$insideSummaryPanel && 'margin-bottom: 35px;'}

  @media (min-width: 768px) {
    ${(props) => props.$insideSummaryPanel && 'margin-bottom: 70px;'}
  }

  ul {
    li {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      line-height: 1.7;

      span:first-child {
        max-width: 75%;
      }

      &.ordinary-price {
        margin-top: ${MARGIN};

        span:last-child {
          color: #4f504a;
          text-decoration: line-through;
        }
      }

      :last-child {
        font-size: ${(props) => (props.$insideSummaryPanel ? '18px' : '20px')};
        font-weight: 500;
        margin-top: ${MARGIN};
        padding-top: ${(props) => (props.bundleHasAnyDiscount ? MARGIN : '0')};
        border-top: ${(props) => (props.bundleHasAnyDiscount ? '1px solid #4f504a;' : 'none')};

        span:first-child {
          color: #000000;
        }

        span:last-child {
          color: ${(props) => (props.bundleHasAnyDiscount ? props.theme.palette.secondary.main : '#000000')};
        }
      }
    }
  }
`
